import { useAppDispatch } from 'core/hooks/use-app-dispatch';
import { useEffect } from 'react';
import { useAppSelector } from 'core/hooks/use-app-selector';
import { useLocation } from 'react-router-dom';
import { usePostChangelogCountQuery } from '../api/changelog-api';
import { setUnreadWhatIsNewCount } from '../store';
import { ChangelogPriorityEnum } from '@uptime-bff/api-contract';

const useChangelogReadCount = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);
  const location = useLocation();
  const { data, isError, isSuccess, isFetching, isLoading, refetch } = usePostChangelogCountQuery(
    {
      filters: {
        priority: [ChangelogPriorityEnum.HIGH, ChangelogPriorityEnum.MEDIUM],
      },
    },
    { skip: !isAuthenticated, refetchOnFocus: true }
  );
  const dispatch = useAppDispatch();
  const unreadChangelogIndicator = useAppSelector((state) => state.changelog.unreadWhatIsNewCount) > 0;

  useEffect(() => {
    if (isAuthenticated) {
      refetch();
    }
  }, [location.pathname, isAuthenticated, refetch]);

  useEffect(() => {
    if (data?.unreadCount !== undefined && !isError && isSuccess) {
      dispatch(setUnreadWhatIsNewCount(data.unreadCount));
    }
  }, [data, isError, isSuccess, dispatch]);

  return { unreadChangelogIndicator, isError, isSuccess, isFetching, isLoading };
};

export { useChangelogReadCount };
